module.exports = __webpack_public_path__ + "static/img/cyber.4059490a.webp";